import { connect } from 'react-redux';
import {
  getCurrentOnDemandClip,
  getCurrentStation,
  getIsFavorite,
  getPlaybackMode,
  playbackModes,
} from 'store/reducers/player';

import PlayerFavorites from './PlayerFavorites';

import { getIsFavoriteClip } from 'store/reducers/favorites';
import { favoritePodcastToggle } from 'actions/favoritePodcast-actions';
import { withAnalytics } from 'analytics';
import { favoriteStationToggle } from 'actions/favoriteStation-actions';
import { isEmpty } from 'util/index';

const mapStateToProps = (state) => {
  const isOnDemand = getPlaybackMode(state) === playbackModes.ON_DEMAND_CLIP;
  const station = getCurrentStation(state);
  const onDemandClip = getCurrentOnDemandClip(state);

  return {
    isOnDemand,
    station,
    onDemandClip,
    isVisible: !isEmpty(station) || !isEmpty(onDemandClip),
    isFavorite: isOnDemand ? getIsFavoriteClip(state, onDemandClip) : getIsFavorite(state, { station }),
  };
};

const favoriteStationToggleWithAnalytics = withAnalytics(favoriteStationToggle, {
  'player_add-type': 'header',
});

const mergeProps = (
  { isOnDemand, station, onDemandClip, isFavorite, isVisible },
  { favoritePodcastToggle, favoriteStationToggle }
) => ({
  isVisible,
  isFavorite,
  toggleFavorite: () => (isOnDemand ? favoritePodcastToggle(onDemandClip) : favoriteStationToggle(station)),
});

export default connect(
  mapStateToProps,
  {
    favoritePodcastToggle,
    favoriteStationToggle: favoriteStationToggleWithAnalytics,
  },
  mergeProps
)(PlayerFavorites);
